import Post from "../post/Post";
import "./posts.scss";
import { useQuery } from "@tanstack/react-query";
import { makeRequest } from "../../axios";

const Posts = ({userId}) => {
  const { isLoading, error, data } = useQuery(['posts'], () =>
  makeRequest.get("/posts?userId="+userId).then((res) => {
    return res.data
  }));

  const posts= [
    {
      userId:1,
      name: "Harry",
      profilePic: "https://images.pexels.com/photos/1186116/pexels-photo-1186116.jpeg?auto=compress&cs=tinysrgb&w=600",
      desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Delectus inventore placeat laborum nihil nesciunt nisi, pariatur at sit deleniti voluptatem.",
      img: "https://images.pexels.com/photos/1164985/pexels-photo-1164985.jpeg?auto=compress&cs=tinysrgb&w=600",

    },
    {
      userId:2,
      name: "Harry",
      profilePic: "https://images.pexels.com/photos/1186116/pexels-photo-1186116.jpeg?auto=compress&cs=tinysrgb&w=600",
      desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Delectus inventore placeat laborum nihil nesciunt nisi, pariatur at sit deleniti voluptatem.",
      
    },
    {
      userId:3,
      name: "Harry",
      profilePic: "https://images.pexels.com/photos/1186116/pexels-photo-1186116.jpeg?auto=compress&cs=tinysrgb&w=600",
      desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Delectus inventore placeat laborum nihil nesciunt nisi, pariatur at sit deleniti voluptatem.",
      img: "https://images.pexels.com/photos/1033202/pexels-photo-1033202.jpeg?auto=compress&cs=tinysrgb&w=600",

    },
  ]

  return <div className="posts">
    {
      // error
      // ? <h4>Something went wrong!</h4>
      // : isLoading
      // ? <h4>LOADING..</h4>
      // : data.map(post => (
       posts.map(post => (
        <Post post={post} key={post.id} />
      ))
    }
  </div>;
};

export default Posts;
